import type { SupabaseClient } from "@supabase/supabase-js";

import { resolveStorageUrl as resolveStorageUrlPure, STORAGE_BUCKET } from "@/lib/storage/url";
import { storageBaseUrl } from "@/lib/storage/public-url";

export { STORAGE_BUCKET };

export function storageBucket(supabase: SupabaseClient) {
  return supabase.storage.from(STORAGE_BUCKET);
}

/**
 * @deprecated Use `resolveStorageUrl` from `@/lib/storage/public-url` — it
 * needs no `SupabaseClient`, so it is callable from pure renders, email
 * templates and server code. Kept as a thin delegating wrapper for the two
 * existing call sites in `lib/showcase-listings.ts`.
 *
 * Behaviour is now the total resolver's (`lib/storage/url.ts`): the old
 * `startsWith("http")` check let `blob:`, `data:` and `/local.svg` fall
 * through to `getPublicUrl()`, which mangled them.
 */
export function resolveStorageUrl(raw: string, _supabase: SupabaseClient): string {
  return resolveStorageUrlPure(raw, storageBaseUrl());
}

function sanitize(title: string): string {
  return title.replace(/[^a-z0-9]/gi, "_").toLowerCase();
}

function rand6(): string {
  return Math.random().toString(36).substring(2, 8);
}

export const StoragePath = {
  listing(title: string, index: number, ext: string): string {
    return `listings/${sanitize(title)}-${Date.now()}-${index}.${ext}`;
  },
  post(title: string, ext: string): string {
    return `posts/${sanitize(title)}-${Date.now()}.${ext}`;
  },
  avatar(userId: string, ext: string): string {
    return `avatars/${userId}-${Date.now()}.${ext}`;
  },
  banner(userId: string, ext: string): string {
    return `profile-banners/${userId}-${Date.now()}.${ext}`;
  },
  chatTemp(userId: string, ext: string): string {
    return `chat-temp/${userId}/${Date.now()}_${rand6()}.${ext}`;
  },
  chatFinal(roomName: string, filename: string): string {
    return `messages/${roomName}/${filename}`;
  },
  moderation(userId: string, ext: string): string {
    return `moderation_attempts/${userId}/${Date.now()}_${rand6()}.${ext}`;
  },
  adminEmail(ext: string): string {
    return `admin-emails/${rand6()}-${Date.now()}.${ext}`;
  },
  productionUpdate(listingId: string, index: number, ext: string): string {
    return `production-updates/${listingId}/${Date.now()}-${index}-${rand6()}.${ext}`;
  },
};
